<template>
    <div>
        <datepicker :inline="false"  :name="name" :value="date"></datepicker>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';

    export default {
        
        props: ['name','date'],
   
        components: {
            Datepicker
        }

    }
</script>
